<div class="container" *ngIf="viewLoaded">
  <sis-tab-navigation [tabs]="tabs" [wide]="'sm'"></sis-tab-navigation>
  <ui-view></ui-view>
</div>
